import { render, staticRenderFns } from "./mod-10.vue?vue&type=template&id=33196875&scoped=true&"
import script from "./mod-10.vue?vue&type=script&lang=js&"
export * from "./mod-10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33196875",
  null
  
)

export default component.exports